/**
 * Instant slide duration so Swiper's realIndex matches React state before the next render.
 * Animated slideTo lags realIndex and can fight the lightbox index sync.
 */
export const LIGHTBOX_GALLERY_SLIDE_SPEED_MS = 0;

type GalleryIndexSync = {
    /** Updates the desktop gallery's focused stack index. */
    setActiveIndex: (stackIndex: number) => void;
    /** Moves Swiper to a stack index, optionally with an animation duration. */
    slideToIndex: (stackIndex: number, speedMs?: number) => void;
};

/**
 * Applies Swiper's realIndex to React state when the lightbox is closed.
 * While the lightbox is open the modal owns activeIndex.
 */
export const applySwiperIndexToGallery = (
    realIndex: number,
    modalOpen: boolean,
    setActiveIndex: (stackIndex: number) => void,
): void => {
    if (modalOpen) return;
    setActiveIndex(realIndex);
};

/**
 * Syncs the desktop gallery and thumbs when the lightbox focused photo changes.
 */
export const applyLightboxSlideToGallery = (
    stackIndex: number,
    { setActiveIndex, slideToIndex }: GalleryIndexSync,
): void => {
    setActiveIndex(stackIndex);
    slideToIndex(stackIndex, LIGHTBOX_GALLERY_SLIDE_SPEED_MS);
};
